/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk } from "@reduxjs/toolkit";
import server from "api/server";
import { signUpAction } from "features/authDashboard/actions/signup.action";
import { DeleteUserAPI, GetUsersAPIRequest, UpdateUserAPIRequest, UserDetails } from "../interfaces/userManagement.interface";

export const getUsers = createAsyncThunk(
  "getUsers",

  async (payload: GetUsersAPIRequest) => {
    try {
      const { data } = await server.adminUserManagement.getUsers(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const getUserDetailsFromEmail = createAsyncThunk(
  "getUserDetailsFromEmail",

  async (payload: GetUsersAPIRequest) => {
    try {
      const { data } = await server.adminUserManagement.getUserDetailsFromEmail(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);


export const deleteUser = createAsyncThunk(
  "deleteUser",

  async (payload: DeleteUserAPI) => {
    try {
      const { data } = await server.adminUserManagement.deleteUser(payload.data, payload.id);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const addUser = createAsyncThunk(
  "addUser",
  async (payload: UserDetails, {dispatch, rejectWithValue }) => {
    try {
      const {first_name: first_name, last_name: last_name, email} = payload;
      const result = await dispatch(signUpAction({first_name, last_name, email, region:"Florida"})); // #TODO: Replace region with States
      if (result.payload) {
        const { data } = await server.adminUserManagement.createNewUser(payload);
        return data;
      }
      return rejectWithValue("Couldn't sign up")
    } catch (error) {
      console.error(error);
    }
  },
);

export const updateUser = createAsyncThunk(
  "updateUser",

  async (payload: UpdateUserAPIRequest) => {
    try {
      const { data } = await server.adminUserManagement.updateUser(payload.data, payload.id);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);

export const userAuditLogs = createAsyncThunk(
  "userAuditLogs",

  async (payload: GetUsersAPIRequest) => {
    try {
      const { data } = await server.adminUserManagement.getUserAuditLogs(payload);
      return data;
    } catch (error) {
      return console.error(error);
    }
  },
);